import { render, staticRenderFns } from "./MumbleCard.vue?vue&type=template&id=3bd398c4&"
import script from "./MumbleCard.vue?vue&type=script&lang=js&"
export * from "./MumbleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports